import type { RezaOpravneniDto } from '@gov-nx/api/generated/reza.types';
import { is } from '@gov-nx/core/types/helpers.types';
import { toDateReadable } from '@gov-nx/utils/common/Date/utils';
import type { useRezaLocale } from '../useRezaLocale';
import { zastupujiciOsobaNazevFO, zastupujiciOsobaNazevPO } from '../utils';
import type { RezaDetailContexts } from './Context';

export const getPOKeyValues = (
	data: RezaOpravneniDto,
	t: ReturnType<typeof useRezaLocale>['t']
): RezaDetailContexts['keyValues'] =>
	[
		data?.zastupujiciOsobaTyp === 'FO'
			? {
					key: t('detail.table.fo-jmeno'),
					value: data
						? zastupujiciOsobaNazevFO(data.zastupujiciOsoba)
						: undefined,
				}
			: undefined,
		data?.zastupujiciOsobaTyp === 'FO'
			? {
					key: t('detail.table.fo-datum-narozeni'),
					value: data?.zastupujiciOsoba?.fyzickaOsoba?.datumNarozeni
						? toDateReadable(
								data?.zastupujiciOsoba?.fyzickaOsoba?.datumNarozeni
							)
						: undefined,
				}
			: undefined,
		data?.zastupujiciOsobaTyp === 'FO'
			? {
					key: t('detail.table.fo-adresa'),
					value: data?.zastupujiciOsoba?.fyzickaOsoba?.adresa?.adresaText,
				}
			: undefined,
		data?.zastupujiciOsobaTyp === 'PO'
			? {
					key: t('detail.table.po-nazev'),
					value: data
						? zastupujiciOsobaNazevPO(data.zastupujiciOsoba)
						: undefined,
				}
			: undefined,
		data?.zastupujiciOsobaTyp === 'PO'
			? {
					key: t('detail.table.po-ico'),
					value: data.zastupujiciOsoba?.pravnickaOsoba?.ico,
				}
			: undefined,
		data?.zastupujiciOsobaTyp === 'PO'
			? {
					key: t('detail.table.po-sidlo'),
					value: data.zastupujiciOsoba?.pravnickaOsoba?.adresa?.adresaText,
				}
			: undefined,
		{
			key: t('detail.table.platnost-od'),
			value: data?.platnostOd ? toDateReadable(data?.platnostOd) : undefined,
		},
		{
			key: t('detail.table.platnost-do'),
			value: data?.platnostDo
				? toDateReadable(data?.platnostDo)
				: t('sablony.detail.table.platnost-do-neomezeno'),
		},
		{
			key: t('detail.table.identifikator'),
			value: data?.kod,
			canCopy: true,
		},
		{
			key: t('detail.table.postupitelny.klic'),
			value: data?.postupitelny
				? t('detail.table.postupitelny.ano')
				: t('detail.table.postupitelny.ne'),
		},
	].filter(is);
